import { createSlice } from "@reduxjs/toolkit";
import { ApplicationUserDetailsDto } from "../api";
import {normalizeApplicationUserRoles} from "../helpers/applicationUserHelper";

const initialState: { currentUser: ApplicationUserDetailsDto | null } = {
    currentUser: null
};

const applicationUserSlice = createSlice({
    name: 'applicationUserSlice',
    initialState,
    reducers: {
        setCurrentUser: (state, action: { payload: ApplicationUserDetailsDto | null }) => {
            state.currentUser = action.payload ? {
                ...action.payload,
                roles: normalizeApplicationUserRoles(action.payload.roles)
            } : null;
        }
    }
});

// these methods only modify the state
export const { setCurrentUser } = applicationUserSlice.actions;

// these methods only read the state
export const getCurrentUser = (state: any) => state.applicationUser.currentUser as ApplicationUserDetailsDto | null;

export default applicationUserSlice.reducer;
